"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifiedPharmacy = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const VerifiedPharmacy_styles_1 = require("./VerifiedPharmacy.styles");
const atome_1 = require("../../../../atome");
const react_native_star_rating_widget_1 = __importDefault(require("react-native-star-rating-widget"));
const Verified_1 = require("../../../../atome/Icon/Icons/Verified");
const hooks_1 = require("../../../../../store/hooks");
const reducers_1 = require("../../../../../store/reducers");
const VerifiedPharmacy = ({ navigation, pharmacy }) => {
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const [showDetails, setShowDetails] = (0, react_1.useState)(false);
    const disable = pharmacy.id === userInformation.patientPharmacyRelation?.id;
    const Details = () => (react_1.default.createElement(react_native_1.View, { key: pharmacy.id, style: { alignItems: 'center' } },
        react_1.default.createElement(react_native_1.View, { style: VerifiedPharmacy_styles_1.styles.divider },
            react_1.default.createElement(react_native_1.Pressable, { style: VerifiedPharmacy_styles_1.styles.buttonGreen, onPress: () => {
                    navigation.navigate('PharmacyDetails', {
                        chosenPharmacy: pharmacy,
                    });
                }, disabled: false },
                react_1.default.createElement(atome_1.Text, { style: [VerifiedPharmacy_styles_1.styles.buttonTextGreen] }, "Details")),
            react_1.default.createElement(react_native_1.Pressable, { style: disable ? VerifiedPharmacy_styles_1.styles.buttonWhiteDisabled : VerifiedPharmacy_styles_1.styles.buttonWhite, onPress: () => navigation.navigate('PharmacyConfirmation', {
                    chosenPharmacy: pharmacy,
                }), disabled: false },
                react_1.default.createElement(atome_1.Text, { style: [
                        disable ? VerifiedPharmacy_styles_1.styles.buttonTextWhiteDisabled : VerifiedPharmacy_styles_1.styles.buttonTextWhite,
                    ] }, disable ? 'Ausgewählte Apotheke' : 'Apotheke Wählen')))));
    return (react_1.default.createElement(react_native_1.View, { style: [VerifiedPharmacy_styles_1.styles.rectangle] },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setShowDetails(!showDetails), style: VerifiedPharmacy_styles_1.styles.infoRow },
            react_1.default.createElement(atome_1.Text, { style: [VerifiedPharmacy_styles_1.styles.titleLeft] }, pharmacy.name),
            react_1.default.createElement(atome_1.Text, { style: [VerifiedPharmacy_styles_1.styles.titleRight] }, pharmacy.city)),
        showDetails ? react_1.default.createElement(Details, null) : react_1.default.createElement(react_native_1.View, { style: VerifiedPharmacy_styles_1.styles.detailsLineGreen }),
        react_1.default.createElement(react_native_1.View, { style: [VerifiedPharmacy_styles_1.styles.ratingRow] },
            react_1.default.createElement(Verified_1.Verified, { color: "#3db384", size: 15, styles: [{ marginRight: 5 }] }),
            react_1.default.createElement(atome_1.Text, { style: [VerifiedPharmacy_styles_1.styles.pharmacyTypeText] }, "Verifizierte Apotheke"),
            react_1.default.createElement(react_native_star_rating_widget_1.default, { rating: Math.ceil(pharmacy.rating), onChange: () => { }, starSize: 16, color: "#3db384", style: VerifiedPharmacy_styles_1.styles.starsStyles, starStyle: VerifiedPharmacy_styles_1.styles.starStyles }))));
};
exports.VerifiedPharmacy = VerifiedPharmacy;
